/**
 * 신청서(전자결재 SignDocs) 도메인 라우트 - 인사기본 > 신청서.
 * route name = OBJECT_ID -> pages/ela. ELA0010·0011·0012·0020·0030·0080·9000 = 실 REST(api/ela) 연동.
 */
const routes = [
  {
    // 신청 내역(구성원 본인) - SG(신청 항목·신청 기간·결재현황) + 결재현황 Grid + 신청서 상세 드로워 (인사기본 > 신청서)
    path: 'ela/apply-history',
    name: 'ELA0010',
    component: () => import('@/pages/ela/ELA0010.vue'),
    meta: {
      requiresAuth: true,
      title: '신청 내역',
      menuId: 'ELA0010',
      objInfo: 'ELA0010 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 임시보관함(구성원 본인) - 검색바 없음 + 임시보관 현황 Grid(☐·번호·신청 항목 ↗·작성일) + [삭제] (인사기본 > 신청서)
    path: 'ela/temp-box',
    name: 'ELA0012',
    component: () => import('@/pages/ela/ELA0012.vue'),
    meta: {
      requiresAuth: true,
      title: '임시보관함',
      menuId: 'ELA0012',
      objInfo: 'ELA0012 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 결재함(결재자) - SG(신청 항목·신청 기간·결재현황[default 결재요청]·신청자) + 체크박스 Grid + [일괄반려][일괄결재] + 결재 상세 드로워 (인사기본 > 신청서)
    path: 'ela/intray',
    name: 'ELA0020',
    component: () => import('@/pages/ela/ELA0020.vue'),
    meta: {
      requiresAuth: true,
      title: '결재함',
      menuId: 'ELA0020',
      objInfo: 'ELA0020 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 기결함(결재자) - SG(신청 항목·신청 기간·신청자) + 기결 Grid(결재일=내 처리일·내 의견) + 상세 드로워(읽기 전용) (인사기본 > 신청서)
    path: 'ela/outtray',
    name: 'ELA0030',
    component: () => import('@/pages/ela/ELA0030.vue'),
    meta: {
      requiresAuth: true,
      title: '기결함',
      menuId: 'ELA0030',
      objInfo: 'ELA0030 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 신청서 양식 관리(관리자) - 3탭(신청서/법정문서/약정문서 양식) + 검색바 + Grid + 양식 편집 드로워 (인사기본 > 신청서)
    path: 'ela/form-mng',
    name: 'ELA0080',
    component: () => import('@/pages/ela/ELA0080.vue'),
    meta: {
      requiresAuth: true,
      title: '신청서 양식 관리',
      menuId: 'ELA0080',
      objInfo: 'ELA0080 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 신청서 작성(구성원 본인) - 3탭(인사잇 신청서/법정 문서/약정 문서) + 신청서 카드 리스트 + 작성 드로워 (인사기본 > 신청서)
    path: 'ela/write',
    name: 'ELA0011',
    component: () => import('@/pages/ela/ELA0011.vue'),
    meta: {
      requiresAuth: true,
      title: '신청서 작성',
      menuId: 'ELA0011',
      objInfo: 'ELA0011 · 인사기본/신청서 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 결재선 관리 - 내 저장 결재라인 목록 + 결재선 빌더(편성·저장·삭제) (환경설정 > 업무 기준 설정)
    path: 'ela/line-mng',
    name: 'ELA9000',
    component: () => import('@/pages/ela/ELA9000.vue'),
    meta: {
      requiresAuth: true,
      title: '결재선 관리',
      menuId: 'ELA9000',
      objInfo: 'ELA9000 · 환경설정/업무 기준 설정 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 대결 관리 - 대결 기간 기준 + 신청서별 대결자 지정 (환경설정 > 업무 기준 설정)
    path: 'ela/substitute',
    name: 'ELA0040',
    component: () => import('@/pages/ela/ELA0040.vue'),
    meta: {
      requiresAuth: true,
      title: '대결 관리',
      menuId: 'ELA0040',
      objInfo: 'ELA0040 · 환경설정/업무 기준 설정 (전자결재 SignDocs · 미래모델·퍼블리싱)',
    },
  },
  {
    // 전자계약 - 4탭(계약요청·요청내역·구성원별·내문서) + 계약 요청 모달 + 현황 드로워 (인사기본 > 신청서)
    path: 'ela/econtract',
    name: 'ECT0010',
    component: () => import('@/pages/ela/ECT0010.vue'),
    meta: {
      requiresAuth: true,
      title: '전자계약',
      menuId: 'ECT0010',
      objInfo: 'ECT0010 · 인사기본/전자계약 (전자결재 SignDocs · 미래모델)',
    },
  },
  // ECT0020 계약서 추가/편집은 별도 라우트가 아니라 ECT0010 내 풀 모달(EctEditorModal)
];

export default routes;
